import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Lookup } from 'src/app/models/lookups/Lookup';
import { AmbassadorWorkExperience } from 'src/app/models/user/AmbassadorWorkExperience';
import { AmbassadorsProfileService } from 'src/app/services/ambassadors-profile.service';
import { LookupsService } from 'src/app/services/lookups.service';
import Swal from 'sweetalert2';
export interface DialogData {
  record: AmbassadorWorkExperience;
}
@Component({
  selector: 'app-work-experiences-form',
  standalone: false,
  templateUrl: './work-experiences-form.component.html'
})
export class WorkExperiencesFormComponent implements OnInit {
  loading = false
  formGroup!: FormGroup
  employmentTypesList: Lookup[] = []
  monthsList: Lookup[] = []
  yearsList: Lookup[] = []
  @ViewChild('form') form!: NgForm;
  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<WorkExperiencesFormComponent>,
    private service: AmbassadorsProfileService,
    private lookupsService: LookupsService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.getAllEmploymentTypes()
    this.getMonths()
    this.generateYears()
    this.initForm()
    if (this.data.record) {
      this.bindData(this.data.record)
    }
    this.formGroup.get('currentlyWorking')?.valueChanges.subscribe(value => {
      this.updateEndDateState(value);
    });
  }
  bindData(record: AmbassadorWorkExperience) {
    this.formGroup.patchValue(
      record, { emitEvent: true }
    )
    this.updateEndDateState(record.currentlyWorking);
  }
  getAllEmploymentTypes() {
    this.lookupsService.getAllEmploymentTypes().subscribe(res => {
      this.employmentTypesList = res
    }, err => {

    })
  }

  getMonths() {
    this.lookupsService.getMonths().subscribe(res => {
      this.monthsList = res
    }, err => {

    })
  }

  generateYears() {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 50;

    this.yearsList = Array.from({ length: 51 }, (_, i) => {
      const year = currentYear - i;
      return { id: year, name: year.toString() };
    });
  }


  initForm() {
    this.formGroup = this.fb.group({
      jobTitle: ['', {
        validators: [
          Validators.required,
        ]
      }],
      companyName: ['', {
        validators: [
          Validators.required,
        ]
      }],
      employmentTypeId: [null, [Validators.required]],

      startDate: this.fb.group({
        month: ['', [Validators.required]],
        year: ['', [Validators.required]]
      }),

      endDate: this.fb.group({
        month: ['', [Validators.required]],
        year: ['', [Validators.required]]
      }),

      currentlyWorking: [false]
     }, { validators: this.dateRangeValidator });
  }


  handelEndDateValue(event) {
    const endDateGroup = this.formGroup.get('endDate');
    const monthControl = endDateGroup?.get('month');
    const yearControl = endDateGroup?.get('year');

    if (event.checked) {
      monthControl?.setValue(null);
      yearControl?.setValue(null);

      monthControl?.clearValidators();
      yearControl?.clearValidators();
    } else {
      monthControl?.setValidators([Validators.required]);
      yearControl?.setValidators([Validators.required]);
    }

    monthControl?.updateValueAndValidity();
    yearControl?.updateValueAndValidity();
  }

  dateRangeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const startGroup = control.get('startDate');
    const endGroup = control.get('endDate');
    const currentlyWorking = control.get('currentlyWorking')?.value;

    if (!startGroup || !endGroup || currentlyWorking) {
      return null;
    }

    const startYear = +startGroup.get('year')?.value;
    const startMonthId = +startGroup.get('month')?.value;
    const endYear = +endGroup.get('year')?.value;
    const endMonthId = +endGroup.get('month')?.value;

    if (!startYear || !endYear || !startMonthId || !endMonthId) {
      return null;
    }


    const startDate = new Date(startYear, startMonthId - 1);
    const endDate = new Date(endYear, endMonthId - 1);
    debugger

    return endDate < startDate ? { dateRangeInvalid: true } : null;
  }


  updateEndDateState(iscurrentlyWorking: boolean) {
    const endDateGroup = this.formGroup.get('endDate');
    if (iscurrentlyWorking) {
      endDateGroup?.disable();
    } else {
      endDateGroup?.enable();
    }
  }

  saveRecord() {
    if (this.formGroup.valid) {
      this.loading = true
      let formControls = this.formGroup.value
      if (this.data.record) formControls.id = this.data.record.id
      this.service.AddOrUpdateAmbassadorWorkExperience(formControls).subscribe(() => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.success'),
          text: this.data.record ? this.translate.instant('swalMsg.updatedsuccessfully') : this.translate.instant('swalMsg.addedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.ok')
        });
        this.dialogRef.close(true)
      }, error => {
        this.loading = false;

        if (error && error.detail) {
          Swal.fire({
            title: this.translate.instant('swalMsg.Failed'),
            text: error.detail,
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.ok')
          });
        }
      });

    }
  }

  hasError(controlName: string, errorName: string, groupName?: string): boolean {
    const path = groupName ? `${groupName}.${controlName}` : controlName;
    const control = this.formGroup.get(path);

    return !!(control && control.hasError(errorName) && (control.touched || this.form?.submitted));
  }
}


